export default __webpack_public_path__ + "static/media/N2P_1898.1e5cbc38.jpg";